// src/hooks/useFileReader.js
import * as XLSX from "xlsx";
import { enqueueSnackbar } from "notistack";

export const useFileReader = (programData) => {
  const readExcel = (file, callback) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const data = event.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const json = XLSX.utils.sheet_to_json(sheet);

        const classNameIdMap = {};
        programData.forEach((p) => {
          classNameIdMap[p.name.toLowerCase().replace(/\s/g, "")] = p.id;
        });

        const finalData = json.map((row, i) => {
          const key = row.class?.toLowerCase().replace(/\s/g, "");
          const program_id = classNameIdMap[key];
          if (!program_id)
            enqueueSnackbar(`Program not found for class ${row.class}`, {
              variant: "error",
            });

          return { ...row, program_id };
        });

        callback(finalData);
      } catch (error) {
        enqueueSnackbar("Failed to read Excel file", { variant: "error" });
      }
    };
    reader.readAsBinaryString(file);
  };

  return { readExcel };
};
